"use client";
import type { MutableRefObject, ReactElement } from "react";
import type { MotionValue } from "framer-motion";
import { PERIOD_SPACING } from "./timeline-constants";
import { selectTimelineDotState, selectTimelineSectionColor, } from "./timeline-root-selectors";
import { TimelinePeriod, type TimelineEventHoverPayload } from "./TimelinePeriod";
import type { TimelinePeriod as TimelinePeriodType } from "./timeline-types";
export interface TimelinePeriodRowProps {
    centeredPeriodIndex: number;
    chartHeight: number;
    collapsedSections: Set<number>;
    needleActive: boolean;
    onHoverEvent: (payload: TimelineEventHoverPayload | null) => void;
    periodRefs: MutableRefObject<Array<HTMLDivElement | null>>;
    periods: TimelinePeriodType[];
    snappedNeedleX: MotionValue<number>;
    snappedPeriodIndex: number | null;
    trackY: number;
}
export function TimelinePeriodRow({ centeredPeriodIndex, chartHeight, collapsedSections, needleActive, onHoverEvent, periodRefs, periods, snappedNeedleX, snappedPeriodIndex, trackY, }: TimelinePeriodRowProps): ReactElement {
    return (
      <div style={{
            position: "relative",
            display: "flex",
            width: periods.length * PERIOD_SPACING,
            height: chartHeight,
            zIndex: 3,
        }}>
        {periods.map((period, periodIndex) => (<div key={`period-col-${period.globalIndex}`} ref={(node) => {
                periodRefs.current[periodIndex] = node;
            }} style={{
                width: PERIOD_SPACING,
                minWidth: PERIOD_SPACING,
                flexShrink: 0,
            }}>
            <TimelinePeriod period={period} sectionColor={selectTimelineSectionColor({
                sectionIndex: period.sectionIndex,
            })} isAbove={period.globalIndex % 2 === 1} isCollapsed={collapsedSections.has(period.sectionIndex)} isSnapped={needleActive && snappedPeriodIndex === period.globalIndex} dotState={selectTimelineDotState({
                centeredPeriodIndex,
                periodGlobalIndex: period.globalIndex,
            })} needleActive={needleActive} needleX={snappedNeedleX} trackY={trackY} chartHeight={chartHeight} onHoverEvent={onHoverEvent}/>
          </div>))}
      </div>
    );
}
